import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import { DEPRECATED_backwardsCompatibleValues } from "@faire/web--source/common/localization";
import { Calendar60 } from "@faire/web--source/slate/icons/CalendarDays";
import { Column, Row } from "@faire/web--source/slate/Layout";
import { Spacer } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import { observer } from "mobx-react";
import * as React from "react";
import styled from "styled-components";
import { useFaireDirectBrand } from "@faire/retailer/hooks/FaireDirect/useFaireDirectBrand/useFaireDirectBrand";
import { useFaireDirectFirstOrderIncentive } from "@faire/retailer/hooks/FaireDirect/useFaireDirectFirstOrderIncentive/useFaireDirectFirstOrderIncentive";
import CuratedSelectionIcon from "@faire/retailer/icons/Collections.svg";
import FreeReturnsIcon from "@faire/retailer/icons/FreeReturn.svg";
import { termsOfServiceLinkFormatting } from "@faire/retailer/views/product/Components/__internal__/utils";
var Wrapper = styled(Column).attrs({
    justify: "flex-start",
    align: "center"
}).withConfig({
    componentId: "sc-4aba27d4-0"
})([
    "width:100%;background-color:",
    ";padding:24px;"
], Core.surface.muted);
var Title = styled(Typography).attrs({
    variant: "pageHeaderSerifRegular",
    align: "center"
}).withConfig({
    componentId: "sc-4aba27d4-1"
})([
    "&&&{font-size:14px;line-height:24px;letter-spacing:0.25px;}"
]);
var PerkRow = styled(Row).attrs({
    align: "center",
    justify: "center"
}).withConfig({
    componentId: "sc-4aba27d4-2"
})([
    "margin-bottom:32px;width:100%;"
]);
var PerkTypography = styled(Typography).attrs({}).withConfig({
    componentId: "sc-4aba27d4-3"
})([
    ""
]);
var Icon = styled(Column).attrs({
    align: "center",
    justify: "center"
}).withConfig({
    componentId: "sc-4aba27d4-4"
})([
    "width:40px;height:40px;border-radius:50%;background-color:",
    ";margin-right:20px;"
], Core.surface.inverse);
var DesktopFaireDirectPerksCardBase = function() {
    var faireDirectBrand = useFaireDirectBrand().faireDirectBrand;
    var _useFaireDirectFirstOrderIncentive = useFaireDirectFirstOrderIncentive(), isFaireDirectCreditPercentageBased = _useFaireDirectFirstOrderIncentive.isFaireDirectCreditPercentageBased, formattedFixedBasedAmount = _useFaireDirectFirstOrderIncentive.formattedFixedBasedAmount;
    if (!faireDirectBrand) {
        return null;
    }
    var _faireDirectBrand_name;
    return /*#__PURE__*/ _jsxs(Wrapper, {
        children: [
            /*#__PURE__*/ _jsx(Typography, {
                align: "center",
                children: /*#__PURE__*/ _jsx("strong", {
                    children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                        id: "v9Jch7",
                        defaultMessage: [
                            {
                                type: 1,
                                value: "brandName"
                            },
                            {
                                type: 0,
                                value: " invited you to Faire!"
                            }
                        ],
                        values: DEPRECATED_backwardsCompatibleValues({
                            brandName: faireDirectBrand.name
                        })
                    })
                })
            }),
            isFaireDirectCreditPercentageBased ? null : /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx(Spacer, {
                        size: 16
                    }),
                    /*#__PURE__*/ _jsx(Title, {
                        children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                            id: "bR7vB6",
                            defaultMessage: [
                                {
                                    type: 0,
                                    value: "Sign up to lock in "
                                },
                                {
                                    type: 1,
                                    value: "promoMoney"
                                },
                                {
                                    type: 0,
                                    value: " off and one year of free shipping to "
                                },
                                {
                                    type: 1,
                                    value: "brandCompanyName"
                                }
                            ],
                            values: {
                                promoMoney: formattedFixedBasedAmount,
                                brandCompanyName: (_faireDirectBrand_name = faireDirectBrand.name) !== null && _faireDirectBrand_name !== void 0 ? _faireDirectBrand_name : ""
                            }
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(Spacer, {
                size: 32
            }),
            /*#__PURE__*/ _jsxs(PerkRow, {
                children: [
                    /*#__PURE__*/ _jsx(Icon, {
                        children: /*#__PURE__*/ _jsx("img", {
                            src: CuratedSelectionIcon,
                            alt: "Easy reordering with year-round shopping",
                            style: {
                                height: "20px",
                                width: "20px"
                            }
                        })
                    }),
                    /*#__PURE__*/ _jsx(Column, {
                        flex: 1,
                        children: /*#__PURE__*/ _jsx(PerkTypography, {
                            children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                                id: "Hmuxpm",
                                defaultMessage: [
                                    {
                                        type: 0,
                                        value: "Easy reordering with year-round shopping"
                                    }
                                ]
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs(PerkRow, {
                children: [
                    /*#__PURE__*/ _jsx(Icon, {
                        children: /*#__PURE__*/ _jsx("img", {
                            src: FreeReturnsIcon,
                            alt: "Free returns for risk-free buying",
                            style: {
                                height: "17px",
                                width: "20px"
                            }
                        })
                    }),
                    /*#__PURE__*/ _jsx(Column, {
                        flex: 1,
                        children: /*#__PURE__*/ _jsx(PerkTypography, {
                            children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                                id: "Ld0jHL",
                                defaultMessage: [
                                    {
                                        type: 0,
                                        value: "Free returns for risk-free buying"
                                    }
                                ]
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs(PerkRow, {
                children: [
                    /*#__PURE__*/ _jsx(Icon, {
                        children: /*#__PURE__*/ _jsx(Calendar60, {
                            height: "20px",
                            width: "20px",
                            titleAccess: "60-day payment terms"
                        })
                    }),
                    /*#__PURE__*/ _jsx(Column, {
                        flex: 1,
                        children: /*#__PURE__*/ _jsx(PerkTypography, {
                            children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                                id: "smoiVt",
                                defaultMessage: [
                                    {
                                        type: 0,
                                        value: "60-day payment terms"
                                    }
                                ]
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(Spacer, {
                size: 8
            }),
            /*#__PURE__*/ _jsx(Typography, {
                color: Core.text.subdued,
                align: "center",
                variant: "labelSansRegular",
                children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                    id: "DRKDn7",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Eligible for new retailers only. By proceeding, you agree to our "
                        },
                        {
                            type: 8,
                            value: "TextLinkFormatting",
                            children: [
                                {
                                    type: 0,
                                    value: "Terms of Service"
                                }
                            ]
                        }
                    ],
                    values: {
                        TextLinkFormatting: termsOfServiceLinkFormatting
                    }
                })
            })
        ]
    });
};
export var DesktopFaireDirectPerksCard = observer(DesktopFaireDirectPerksCardBase);
